// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.QuestionsTabs {
  max-width: 600px;
  margin-top: 1.5rem;
}
.QuestionsTabs .list-group-item {
  background: transparent;
  display: flex;
  justify-content: center;
  gap: 0.25rem;
  color: var(--bs-primary);
  font-weight: 600;
  font-size: 18px;
  text-transform: capitalize;
  border: none;
  border-bottom: 3px solid var(--bs-primary);
  border-radius: 0;
}
.QuestionsTabs .list-group-item.active {
  background-color: transparent;
  border-color: var(--bs-secondary);
  border-width: 5px;
  color: var(--bs-secondary);
}
.QuestionsTabs .list-group-item-action:not(.active):focus {
  background: transparent;
  color: var(--bs-primary);
}
.QuestionsTabs .list-group-horizontal > .list-group-item:first-child:not(:last-child) {
  border-radius: 0;
}`, "",{"version":3,"sources":["webpack://./src/features/Settings/pages/Questions/components/QuestionsTabs/styles.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,kBAAA;AACF;AACE;EACE,uBAAA;EACA,aAAA;EACA,uBAAA;EACA,YAAA;EACA,wBAAA;EACA,gBAAA;EACA,eAAA;EACA,0BAAA;EACA,YAAA;EACA,0CAAA;EACA,gBAAA;AACJ;AAAI;EACE,6BAAA;EACA,iCAAA;EACA,iBAAA;EACA,0BAAA;AAEN;AACE;EACE,uBAAA;EACA,wBAAA;AACJ;AACE;EACE,gBAAA;AACJ","sourcesContent":[".QuestionsTabs {\n  max-width: 600px;\n  margin-top: 1.5rem;\n\n  .list-group-item {\n    background: transparent;\n    display: flex;\n    justify-content: center;\n    gap: 0.25rem;\n    color: var(--bs-primary);\n    font-weight: 600;\n    font-size: 18px;\n    text-transform: capitalize;\n    border: none;\n    border-bottom: 3px solid var(--bs-primary);\n    border-radius: 0;\n    &.active {\n      background-color: transparent;\n      border-color: var(--bs-secondary);\n      border-width: 5px;\n      color: var(--bs-secondary);\n    }\n  }\n  .list-group-item-action:not(.active):focus {\n    background: transparent;\n    color: var(--bs-primary);\n  }\n  .list-group-horizontal > .list-group-item:first-child:not(:last-child) {\n    border-radius: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
